import { MEETING_STATUS_CANCELLED, isMeetingCancelled } from 'common-data-handling';

export function isUserMeetingCancelled(userId, meeting) {
    return (
        // state is cancelled
        isMeetingCancelled(meeting) ||
        // user cancelled/rejected meeting
        meeting.invited.find((invite) => invite.user_id == userId)?.state == MEETING_STATUS_CANCELLED
    );
}
